// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__hypeSkewedFont_36fbcc', '__hypeSkewedFont_Fallback_36fbcc'"},"className":"__className_36fbcc"};